import { Modal, Row, Col, Button } from 'react-bootstrap'

import styles from './styles.module.css'

function ConfirmationModal({ action, message, show, closeModal }) {
  return (
    <Modal centered show={show} onHide={closeModal}>
      <Modal.Header closeButton />
      <Modal.Body>
        <p style={{ fontSize: 15, fontWeight: 500 }}>{message}</p>
        <Row>
          <Col>
            <Button className={`${styles.btnn} ${styles.btnnNo}`} onClick={closeModal}>
              Não
            </Button>
          </Col>
          <Col>
            <Button className={`${styles.btnn} ${styles.btnnYes}`} onClick={action}>
              Sim
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ConfirmationModal
